import { TopBar } from "../../../widgets";

const CommunityPolicy = () => {
    return <>
        <TopBar type='closeIcon' title="커뮤니티 서비스 운영정책" rightIcon={false} styles={{ title: { paddingInline: 0 } }} />
        <div className="body/b2" style={{ padding: '24px 20px', color: "#555555" }}>
            <div className="sub-title/st2">1. 목적</div>
            <div>
                파지티브호텔 커뮤니티(이하 "커뮤니티")는 요가, 웰니스, 명상, 일상에 대한 경험과 인사이트를 자유롭게 나누고 서로 응원하는 공간입니다. 본 운영 정책은 커뮤니티를 건강하고 긍정적인 방향으로 운영하기 위해 마련되었습니다.
            </div>
            <br />
            <div className="sub-title/st2">2. 적용 범위</div>
            <div style={{ display: 'flex', alignItems: 'start' }}>
                <div style={{ paddingInline: '6px' }}> · </div><div>본 정책은 파지티브호텔 앱 내 커뮤니티 탭에서 생성되는 모든 게시글, 댓글, 이미지 및 기타 콘텐츠에 적용됩니다.</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'start' }}>
                <div style={{ paddingInline: '6px' }}> · </div><div>커뮤니티 이용자는 본 정책에 동의하고 이를 준수해야 합니다.</div>
            </div>
            <br />
            <div className="sub-title/st2">3. 운영 원칙</div>
            <div>① 우리는 이렇게 소통합니다.
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>다양한 웰니스 경험과 일상 이야기를 자유롭게 나눌 수 있습니다.</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>서로를 존중하며, 따뜻한 말과 태도를 지향합니다.</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>잘 모르거나 다른 관점이더라도 열린 마음으로 바라봅니다.</div>
                </div>
            </div>
            <br />
            <div>
                ② 아래와 같은 행위는 제한됩니다.
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>욕설, 비방, 혐오 표현, 공격적인 언행</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>스팸성 글, 홍보성 게시물, 외부 링크 과다 포함</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>개인정보(본인 및 타인)의 노출</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>저작권, 초상권 등을 침해하는 콘텐츠 게시</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>음란물, 폭력적 콘텐츠, 불쾌감을 줄 수 있는 사진/영상</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{ paddingInline: '6px' }}> · </div><div>기타 커뮤니티 취지에 부합하지 않는 행위</div>
                </div>
            </div>
            <br />
            <div className="sub-title/st2">4. 신고 및 제재 기준</div>
            <br />
            <table style={{ textAlign: 'center', marginBottom: '12px' }}>
                <thead className="sub-title/st1" style={{ backgroundColor: 'var(--secondarys100)' }}>
                    <tr>
                        <th style={{ width: '33.33%', paddingBlock: '8px' }}>위반 유형</th>
                        <th style={{ width: '33.33%', paddingBlock: '8px' }}>조치</th>
                        <th style={{ width: '33.33%', paddingBlock: '8px' }}>비고</th>
                    </tr>
                </thead>
                <tbody className="body/b1">
                    <tr>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>경미한 정책 위반<br />(ex. 광고성 댓글)</td>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>게시물 숨김</td>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>1회 경고 후 반복 시 제재</td>
                    </tr>
                    <tr>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>명백한 금지 행위<br />(ex. 욕설, 혐오 표현, 저작권 침해)</td>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>게시물 즉시 삭제 및<br />이용 제한</td>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>상황에 따라 7일<br />또는 영구 이용 제한</td>
                    </tr>
                    <tr>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>반복적 또는<br />악의적 위반</td>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>계정 영구 정지</td>
                        <td style={{ borderBottom: '1px solid var(--secondarys100)', padding: '20px  8px' }}>운영 판단에 따라<br />조기 조치 가능</td>
                    </tr>
                </tbody>
            </table>
            <div>※ 신고된 콘텐츠는 운영자의 판단에 따라 임시 숨김 또는 삭제 처리되며, 사전 통지 없이 조치될 수 있습니다.</div>
            <br />

            <div className="sub-title/st2">5. 게시물 관리 및 삭제</div>
            <div style={{ display: 'flex', alignItems: 'start' }}>
                <div style={{ paddingInline: '6px' }}> · </div><div>운영자는 본 정책 또는 관련 법령을 위반한 게시물에 대해 사전 고지 없이 게시중단 또는 삭제할 수 있습니다.</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'start' }}>
                <div style={{ paddingInline: '6px' }}> · </div><div>본인의 게시물이 삭제된 경우, 앱 내 신고/문의 기능을 통해 소명을 요청할 수 있습니다.</div>
            </div>
            <br />
            <div className="sub-title/st2">6. 정책 안내 및 개정</div>
            <div style={{ display: 'flex', alignItems: 'start' }}>
                <div style={{ paddingInline: '6px' }}> · </div><div>본 정책은 커뮤니티 진입 시 최초 1회 팝업으로 안내되며, 앱 MY {'>'} 설정 {'>'} 이용약관 및 정책 메뉴에서 언제든지 확인할 수 있습니다.</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'start' }}>
                <div style={{ paddingInline: '6px' }}> · </div><div>운영 정책은 커뮤니티의 성격 및 이용 상황에 따라 변경될 수 있으며, 변경 시 공지사항 또는 앱 알림을 통해 사전 안내드립니다.</div>
            </div>
            <br />
            <div className="sub-title/st2">7. 문의 및 이의제기</div>
            <div>커뮤니티 이용 중 불편 사항이나 이의가 있을 경우, 앱 내 [문의하기] 기능을 통해 운영팀에 의견을 전달해 주세요.</div>
            <br />
            <div>본 커뮤니티는 회원 간의 건강한 웰니스 소통을 위한 공간입니다. 운영 정책을 함께 지켜나가며 따뜻한 커뮤니티 문화를 만들어가요.</div>
            <br />
            <div>주식회사 파지티브호텔 드림</div>
            <br />
            <br />
        </div>
    </>
}

export default CommunityPolicy;
